var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Customer component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCustomer extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.16095 2.605C5.00995 2.60395 4.86165 2.64512 4.7328 2.72386C4.60436 2.80235 4.50034 2.91506 4.43237 3.04933L3.0698 5.78564H20.9305L19.5686 3.05065L19.5679 3.04933C19.5 2.91505 19.396 2.80235 19.2675 2.72386C19.1387 2.64512 18.9904 2.60395 18.8394 2.605L18.8342 2.60502L5.16095 2.605ZM2.6084 9.65638V7.25886C2.66604 7.27632 2.72674 7.28564 2.78942 7.28564H21.2074C21.2713 7.28564 21.3332 7.27593 21.3919 7.25778V9.65638C21.3919 9.66437 21.3888 9.67204 21.3831 9.67769C21.3775 9.68334 21.3698 9.68651 21.3618 9.68651H2.63853C2.63054 9.68651 2.62288 9.68334 2.61722 9.67769C2.61157 9.67203 2.6084 9.66437 2.6084 9.65638ZM5.16853 1.10502C4.73896 1.10256 4.3172 1.21992 3.95062 1.44394C3.58323 1.66846 3.28589 1.99117 3.09215 2.37569L1.18703 6.20152C1.13531 6.30538 1.1084 6.41981 1.1084 6.53583V9.65638C1.1084 10.0622 1.26961 10.4514 1.55656 10.7383C1.84352 11.0253 2.23272 11.1865 2.63853 11.1865H2.6687V16.6775V21.3584C2.6687 21.7642 2.82991 22.1534 3.11687 22.4404C3.40382 22.7273 3.79302 22.8885 4.19884 22.8885H13.4611C13.4936 22.8928 13.5268 22.8951 13.5605 22.8951C13.5943 22.8951 13.6275 22.8928 13.66 22.8885H19.8016C20.2074 22.8885 20.5966 22.7273 20.8835 22.4404C21.1705 22.1534 21.3317 21.7642 21.3317 21.3584V11.1865H21.3618C21.7676 11.1865 22.1568 11.0253 22.4438 10.7383C22.7307 10.4514 22.8919 10.0622 22.8919 9.65638V6.53583C22.8919 6.41981 22.865 6.30538 22.8133 6.20152L20.9098 2.37885L20.9082 2.37569C20.7144 1.99117 20.4171 1.66846 20.0497 1.44394C19.6831 1.21992 19.2614 1.10256 18.8318 1.10502H5.16853ZM19.8317 11.1865H14.3105L14.3105 21.3885H19.8016C19.8095 21.3885 19.8172 21.3853 19.8229 21.3797C19.8285 21.374 19.8317 21.3664 19.8317 21.3584V11.1865ZM12.8105 11.1865H4.1687V15.9275H12.8105V11.1865ZM4.1687 21.3584V17.4275H12.8105V21.3885H4.19884C4.19084 21.3885 4.18318 21.3853 4.17753 21.3797C4.17188 21.374 4.1687 21.3664 4.1687 21.3584Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCustomer.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCustomer.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCustomer.prototype, "size", void 0);
if (customElements.get('cat-icon-customer') === undefined) {
    customElements.define('cat-icon-customer', BlocksIconCustomer);
}
